import { token } from '@/infrastructure/container';
import { type IDomKeyboard } from '@/services/DomKeyboard';

/**
 * Top-level boot coordinator. Starts document-level listeners (keydown) at construction.
 * Eager-resolved in main.tsx so the listeners attach before the first render.
 */
export class AppStore {
  constructor(keyboard: IDomKeyboard) {
    keyboard.start();
  }
}

export const TOKEN_AppStore = token<AppStore>('AppStore');
